import { customEvent, generateLeadEvent } from "../../../modules/tracking/AnalyticsEvents";

export default async function () {
    const locationData = await window.LocationDataLoader.get();

    $.ajax({
        url: "/young-drivers/ask-a-question",
        type: "GET",
        cache: false,
        dataType: "html",
        success: function(response)
        {
            $('[data-remodal-id=modal]').html(response);
            if (brand == '') {
                $('#ask-a-question-brand').val('randd');
            }
            else {
                $('#ask-a-question-brand').val(brand);
            }

            customEvent('Young Drivers', 'Ask a question', 'Opened');

            inst.open();
            var contactFormValidator = new ContactFormValidator;
            contactFormValidator.validate('ask-a-question-form');

            var locationHandler = new CustomerLocationHandler({ locations: locationData.filter(location => location.brand !== 'vauxhall') });
            locationHandler.setup('ask-a-question-form');

            $('#ask-a-question-form').on('submit', async function() {
                if (await contactFormValidator.isValid()) {
                    var formData = $(this).serialize();
                    contactFormValidator.preventInput();
                    $.ajax({
                        type: "POST",
                        cache: false,
                        dataType: 'json',
                        url: $("#ask-a-question-form").attr('action'),
                        data: formData,
                        success: function(response) {
                            customEvent('Young Drivers', 'Ask a question', 'Complete');
                            trackPageView('/conversion/young-drivers-ask-a-question/complete', 'Young Drivers Ask a question Completed');
                            generateLeadEvent('young_drivers_question');

                            if (typeof response.name !== 'undefined') {
                                $('#ask-a-question-form').html('<h2>Thank you for your enquiry</h2><p class="nice-text">Your enquiry has been sent to ' + response.name + '.<br />Someone will be in touch soon to discuss your enquiry</p>');
                            }
                            else {
                                $('#ask-a-question-form').html('<h2>Thank you for your enquiry</h2><p class="nice-text">Your enquiry has been sent to your nearest dealer.<br />Someone will be in touch soon to discuss your enquiry</p>');
                            }
                            contactFormValidator.allowInput();
                        },
                        error: function(response) {
                            outputErrorToForm('ask-a-question-form', parseErrorResponse(response));
                            contactFormValidator.allowInput();
                        }
                    });
                }
                return false;
            });
        }
    });
}